// extracted by mini-css-extract-plugin
export default {"on-cart-container":"styles_on-cart-container__nwK8e","on-card-container":"styles_on-card-container__nMTc8","title-add-on-with-icon":"styles_title-add-on-with-icon__oWdX-"};